export const Fonts = {
    JALDI: 'Jaldi',
    INTER: 'Inter'
}